<template>
  <div>
    <breadcrumb :items="items"/>
    <p>{{ $t('app.team') }}</p>
  </div>
</template>

<script>
export default {
  components: {
    Breadcrumb: () => import('@/components/Breadcrumb.vue'),
  },
  data() {
    return {
      items: [
        {
          text: this.$t('app.dashboard'),
          disabled: true,
          href: 'dashboard',
        },
        {
          text: this.$t('app.team'),
          disabled: false,
          href: 'teams',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
  @import '~styles/views/_team.scss';
</style>
